// Your settings › Appearance › This device: "Install app" (HARDEN-pwa, pwa/install.ts). Where the
// browser offers its install prompt, a button shows it; on iPhone and iPad Safari, the steps
// (Share › Add to Home Screen); running installed, or with nothing to offer, the group is absent.
import { Button, SettingsGroup, SettingsRow, toast } from "@companyos/ui";
import { DownloadIcon, ShareIcon } from "lucide-react";
import { type InstallState, useInstallState } from "../../pwa/install";

export function InstallAppGroup({ state: given }: { state?: InstallState } = {}) {
  const live = useInstallState();
  const state = given ?? live;
  if (state.kind === "installed" || state.kind === "unavailable") return null;
  return (
    <SettingsGroup id="install" title="This device">
      {state.kind === "available" ? (
        <SettingsRow
          label="Install CompanyOS"
          hint="Its own window and an icon in your dock or on your home screen. Works like the website."
        >
          <Button
            size="sm"
            variant="secondary"
            onClick={() =>
              void state.install().then((outcome) => {
                if (outcome === "accepted") toast.add({ title: "CompanyOS is installed" });
              })
            }
          >
            <DownloadIcon aria-hidden="true" />
            Install app
          </Button>
        </SettingsRow>
      ) : (
        <SettingsRow
          wide
          label="Add to Home Screen"
          hint={
            <span data-slot="install-ios-hint">
              In Safari, tap Share{" "}
              <ShareIcon aria-hidden="true" className="inline size-3.5 align-[-2px]" />, then Add to
              Home Screen. CompanyOS then opens like an app, and can send you push notifications.
            </span>
          }
        />
      )}
    </SettingsGroup>
  );
}
